export default __webpack_public_path__ + "static/media/shift.65fdfcb4.svg";